import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Menu, MenuItem } from './va-menu';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { VaIconModule } from '../../va-icon/icon.module';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      hr {
        width: unset;
        margin: 0;
        border: 0;
        border-top: 1px solid #e0e0e0;
      }
      ::ng-deep .mat-mdc-menu-content {
        padding-top: unset;
        padding-bottom: unset;
      }
      .menu-item {
        display: flex;
        align-items: center;
      }
      span.menu-item-text {
        flex-grow: 1;
      }
      mat-icon.right-icon {
        margin-right: 0;
      }
      .container {
        display: flex;
        align-items: center;
        gap: 8px;
      }
    `,
  ],
  template: `
    <div class="container">
      @if (title) {
        <span>{{ title }}</span>
      }
      <button mat-icon-button [matMenuTriggerFor]="menuRef" color="primary">
        <mat-icon>{{ triggerIcon }}</mat-icon>
      </button>
    </div>
    <mat-menu #menuRef="matMenu">
      @for (menu of config.menuItems; track menu) {
        @if (menu.showTopDivider) {
          <hr />
        }
        @if (!menu.link) {
          <button
            mat-menu-item
            class="menu-item"
            [disabled]="menu.disabled"
            [attr.data-pendo]="menu.pendo"
            (click)="onClick(menu)"
            [glxyTooltip]="menu.toolTip || ''"
            >
            @if (menu.leftIcon) {
              <mat-icon>{{ menu.leftIcon }}</mat-icon>
            }
            @if (menu.leftIconImageUrl) {
              <va-icon [iconUrl]="menu.leftIconImageUrl" [iconName]="menu.text" />
            }
            <span class="menu-item-text">{{ menu.text }}</span>
            @if (menu.rightIcon) {
              <mat-icon class="right-icon">{{ menu.rightIcon }}</mat-icon>
            }
          </button>
        }
        @if (menu.link && !menu.link.external) {
          <a
            class="menu-item"
            [disabled]="menu.disabled"
            [routerLink]="menu.link.url"
            [target]="menu.link.target"
            [attr.data-pendo]="menu.pendo"
            (click)="onClick(menu)"
            [glxyTooltip]="menu.toolTip || ''"
            mat-menu-item
            >
            @if (menu.leftIcon) {
              <mat-icon>{{ menu.leftIcon }}</mat-icon>
            }
            @if (menu.leftIconImageUrl) {
              <va-icon [iconUrl]="menu.leftIconImageUrl" [iconName]="menu.text" />
            }
            <span class="menu-item-text">{{ menu.text }}</span>
            @if (menu.rightIcon) {
              <mat-icon class="right-icon">{{ menu.rightIcon }}</mat-icon>
            }
          </a>
        }
        @if (menu.link && menu.link.external) {
          <a
            class="menu-item"
            [disabled]="menu.disabled"
            [href]="menu.link.url"
            [target]="menu.link.target"
            [attr.data-pendo]="menu.pendo"
            (click)="onClick(menu)"
            [glxyTooltip]="menu.toolTip || ''"
            mat-menu-item
            >
            @if (menu.leftIcon) {
              <mat-icon>{{ menu.leftIcon }}</mat-icon>
            }
            @if (menu.leftIconImageUrl) {
              <va-icon [iconUrl]="menu.leftIconImageUrl" [iconName]="menu.text" />
            }
            <span>{{ menu.text }}</span>
            @if (menu.rightIcon) {
              <mat-icon class="right-icon">{{ menu.rightIcon }}</mat-icon>
            }
          </a>
        }
      }
    </mat-menu>
    `,
  imports: [CommonModule, RouterModule, VaIconModule, MatIconModule, MatMenuModule, MatButtonModule, GalaxyTooltipModule],
})
export class VaMenuComponent {
  @Input() config: Menu;

  onClick(menuItem: MenuItem): void {
    if (menuItem.click) {
      menuItem.click();
    }
  }

  get triggerIcon(): string {
    return this.config.triggerIcon ? this.config.triggerIcon : 'more_vert';
  }

  get title(): string {
    return this.config.title ? this.config.title : '';
  }
}
